import { createFileRoute } from '@tanstack/react-router';
import { SitesPage } from '@/features/sites';
import { z } from 'zod';

const sitesSearchSchema = z.object({
  tab: z.string().optional(),
});

export const Route = createFileRoute('/projects/$projectId/sites/')({
  component: SitesPageWrapper,
  validateSearch: sitesSearchSchema,
});

function SitesPageWrapper() {
  const { projectId } = Route.useParams();
  return <SitesPage searchParams={{ projectId: Number(projectId) }} />;
}
